import React from "react";
import Photo from "./photos";

const ImageGallery = ({ images }) => {
  return (
    <div className="flex flex-wrap">
      {images.map((image, index) => (
        <Photo key={index} src={image} />
      ))}
    </div>
  );
};

export default ImageGallery;
